import styled from "styled-components";

export const StyledLoggedOutLayoutWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.netural100};
  padding: 4.8rem 7.2rem 4rem;
  margin: 0;
  position: relative;
  @media (max-width: ${({ theme }) => theme.breakpoints.l}px) {
    padding: 2rem 2rem 2rem;
    gap: 40px;
  }
`;

export const StyledLoggedOutLayoutContent = styled.main`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledLoggedOutLayoutLogo = styled.img`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: ${({ theme }) => theme.colors.white};
  @media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
    top: 8rem;
  }
`;

export const StyledLoggedOutLayoutNav = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4rem;
  position: relative;
`;

export const StyledLoggedOutLayoutFooter = styled.footer``;

export const FooterSection = styled.div`
	width: 636px;
	max-width: 100%;
	display: flex;
	flex-direction: column;
	gap: 24px;
	align-items: center;
	margin-top: 40px;
	
	@media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
		width: 100%;
		max-width: calc(100vw - 32px);
		gap: 16px;
	}
`;

export const FooterText = styled.p`
	font-family: "Inter", sans-serif;
	font-weight: 400;
	font-size: 12px;
	line-height: 20px;
	color: ${({ theme }) => theme.colors.netural500};
	text-align: center;
	margin: 0;
	white-space: pre-wrap;
`;

export const Divider = styled.div`
	width: 100%;
	height: 1px;
	background-color: ${({ theme }) => theme.colors.netural200};
`;

export const CopyrightText = styled.p`
	font-family: "Inter", sans-serif;
	font-weight: 600;
	font-size: 12px;
	line-height: 20px;
	color: ${({ theme }) => theme.colors.netural600};
	text-align: center;
	margin: 0;
	white-space: pre-wrap;
`;

export const BackButton = styled.button`
  border: 1.5px solid ${({ theme }) => theme.colors.primary100};
  background: #fff;
  border-radius: 8px;
  width: 144px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 32px;
  cursor: pointer;
  box-sizing: border-box;
  margin-right: 12px;
  transition: box-shadow 0.2s;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.primary300};
  &:hover {
    opacity: 0.8;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
    height: 46px;
    width: 120px;
	padding: 0;
  }
`;
